import { render } from "./LastProjets.vue?vue&type=template&id=7766ed96&scoped=true"
import script from "./LastProjets.vue?vue&type=script&lang=js"
export * from "./LastProjets.vue?vue&type=script&lang=js"

import "./LastProjets.vue?vue&type=style&index=0&id=7766ed96&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7766ed96"]])

export default __exports__